import i18next from 'shared/i18n/i18next';
import { i18nDynamic } from 'shared/i18n';
import { ApiError } from 'shared/api/client';

const resolve = (key: string): string | undefined => (i18next.exists(key) ? i18nDynamic(key) : undefined);

const statusOf = (error: unknown): number | undefined => {
  const status = (error as { status?: unknown } | null | undefined)?.status;
  if (typeof status === 'number') return status;
  if (typeof status === 'string' && status !== '') return Number(status) || undefined;
  return undefined;
};

const codeOf = (error: unknown): string | undefined => (error instanceof ApiError ? error.code : undefined);

const lookup = (error: unknown, suffix: 'title' | 'message'): string | undefined => {
  const code = codeOf(error);
  const status = statusOf(error);
  return (code ? resolve(`server:error.${code}.${suffix}`) : undefined) ?? (status ? resolve(`server:error.${status}.${suffix}`) : undefined);
};

/**
 * Resolves the copy for a failed request: the backend's `code` first, then its HTTP
 * status, then the caller's own fallback. Handles both an `ApiError` from `api.*` and
 * the plain `{ status }` rejection the legacy `request.*` calls still produce. The
 * backend's `devMessage` is deliberately never rendered — it is English diagnostic
 * text, not user-facing copy.
 */
export const apiErrorText = (error: unknown, fallback: string): string => lookup(error, 'message') ?? fallback;

export const apiErrorTitle = (error: unknown, fallback?: string): string | undefined => lookup(error, 'title') ?? fallback;
